import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initSilResultSafetyFunctionState: types.SilResultSafetyFunctionState = {
    safetyFunctionList: [],
    calculatedSafetyFunctionList: {},
    updatedDevices: 0,

    reloadList: true,
}

const silResultSafetyFunctionReducer = produce((
    draft: types.SilResultSafetyFunctionState = initSilResultSafetyFunctionState,
    action: ActionTypes = null,
): types.SilResultSafetyFunctionState => {
    switch (action.type) {
        case types.SIL_RESULT_SAFETY_FUNCTION_LIST:
            draft.safetyFunctionList = action.safetyFunctionList
            return draft

        case types.SIL_RESULT_CALCULATED_SAFETY_FUNCTION:
            draft.calculatedSafetyFunctionList = {
                ...draft.calculatedSafetyFunctionList,
                [action.safetyFunction.id]: action.safetyFunction,
            }
            return draft

        case types.SIL_RESULT_UPDATED_DEVICES:
            draft.updatedDevices = action.updatedDevices
            return draft

        case types.SIL_RESULT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        default:
            return draft
    }
})
export default silResultSafetyFunctionReducer
